<template>
    <div>
        <div id="diff-chart-container" style="width: 100%; height: 500px;"></div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import Http from "../apis/teach";

export default {
    props:{
        trem:Array,
        default:()=>[]
    },
    mounted() {
        //this.getDiffChart();
    },

    watch:{
        trem:{
            handler(newVal,oldVal){
                this.getDiffChart();
            },
            immediate:true
        }
    },

    beforeDestroy() {
        // 清除 resize 监听并销毁图表实例
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
        }
        const dom = document.getElementById('diff-chart-container');
        if (dom) {
            const instance = echarts.getInstanceByDom(dom);
            if (instance) {
                instance.dispose();
            }
        }
    },
    methods: {
        getDiffChart() {
            Http.getDiffChart({trem:this.trem})
                .then((res) => {
                    // 假设 res.data 为二维数组，直接传入
                    this.initChart(res.data);
                })
                .catch((err) => {
                    console.error('获取数据失败:', err);
                    // 可显示错误提示
                });
        },

        initChart(data) {
            const dom = document.getElementById('diff-chart-container');
            // 若已有实例则先销毁
            let myChart = echarts.getInstanceByDom(dom);
            if (myChart) {
                myChart.dispose();
            }
            myChart = echarts.init(dom, null, {
                renderer: 'canvas',
                useDirtyRect: false,
            });

            // ----- 数据解析 -----
            if (!Array.isArray(data) || data.length < 2) {
                // 数据无效时显示空状态
                myChart.setOption({
                    title: {
                        text: '暂无数据',
                        left: 'center',
                        top: 'center',
                        textStyle: { color: '#999', fontSize: 16 },
                    },
                });
                // 仍需绑定自适应（以防窗口变化）
                this._resizeHandler = () => myChart.resize();
                window.addEventListener('resize', this._resizeHandler);
                return;
            }

            const headers = data[0]; // ['product', '20252-4', '20261-4', ...]
            const seriesNames = headers.slice(1); // 系列名称列表
            const categories = [];
            const seriesData = seriesNames.map(() => []); // 每个系列一个数组

            for (let i = 1; i < data.length; i++) {
                const row = data[i];
                if (!row || row.length < 2) continue;
                categories.push(String(row[0] || ''));
                for (let j = 1; j < row.length; j++) {
                    const val = parseFloat(row[j]);
                    if (j - 1 < seriesData.length) {
                        seriesData[j - 1].push(isNaN(val) ? 0 : val);
                    }
                }
            }

            // ----- 构建 ECharts 配置 -----
            const colors = ['#5470c6', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452'];
            const option = {
                // 工具箱：包含保存为图片功能
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '保存为图片',
                            pixelRatio: 2,
                            backgroundColor: '#fff',
                        },
                    },
                    right: 20,
                    top: 10,
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                    formatter: function (params) {
                        let html = `<strong>${params[0].axisValue}</strong><br/>`;
                        params.forEach((item) => {
                            html += `${item.marker} ${item.seriesName}：${item.value} 人<br/>`;
                        });
                        return html;
                    },
                },
                legend: {
                    data: seriesNames,
                    top: 10,
                    right: 80, // 避开工具箱
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '8%',
                    top: '18%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    data: categories,
                    axisLabel: {
                        fontSize: 12,
                    },
                },
                yAxis: {
                    type: 'value',
                    name: '人数（人）',
                    nameTextStyle: {
                        fontSize: 12,
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#e8e8e8',
                            type: 'dashed',
                        },
                    },
                },
                series: seriesNames.map((name, index) => ({
                    name: name,
                    type: 'bar',
                    data: seriesData[index] || [],
                    barWidth: '30%',
                    barGap: '10%',
                    itemStyle: {
                        color: colors[index % colors.length],
                        borderRadius: [4, 4, 0, 0],
                    },
                    label: {
                        show: true,
                        position: 'top',
                        fontSize: 12,
                        formatter: (params) => params.value,
                    },
                })),
            };

            myChart.setOption(option, true);

            // 自适应
            this._resizeHandler = () => myChart.resize();
            window.addEventListener('resize', this._resizeHandler);
        },
    },
};
</script>

<style scoped>
/* 无需额外样式，容器高度已在行内设置 */
</style>